function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import { reStyleCategory } from '../../utils';

var DiBeforeAfter = function (_Component) {
    _inherits(DiBeforeAfter, _Component);

    function DiBeforeAfter(props) {
        _classCallCheck(this, DiBeforeAfter);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            lineBoundaryPos: -.05,
            lineWidth: 120
        };
        _this.moveLine = _this.moveLine.bind(_this);
        return _this;
    }

    DiBeforeAfter.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.linePos && this.beforeAfterWrapBCR().width) {
            this.setState({ linePos: this.beforeAfterWrapBCR().width * this.state.lineBoundaryPos });
        }
    };

    DiBeforeAfter.prototype.moveLine = function moveLine(pageX, pageY) {
        var nextLeftPos = pageX - this.state.shiftX;
        if (nextLeftPos >= this.state.minLeftPos && nextLeftPos <= this.state.maxLeftPos && pageY > this.state.bcr.top && pageY < this.state.bcr.bottom) {
            this.setState({ linePos: nextLeftPos });
        }
    };

    DiBeforeAfter.prototype.mouseMoveOnLine = function mouseMoveOnLine(event) {
        if (this.state.dragging) {
            console.log('mouseMoveOnLine');

            var _getPageXY = this.getPageXY(event),
                pageX = _getPageXY.pageX,
                pageY = _getPageXY.pageY;

            requestAnimationFrame(this.moveLine.bind(this, pageX, pageY));
        } else {
            console.log('dragging false');
        }
        // event.preventDefault();
    };

    DiBeforeAfter.prototype.mouseUpOffLine = function mouseUpOffLine(event) {
        console.log('mouseUpOffLine');
        this.setState({ dragging: false });
        event.preventDefault();
    };

    DiBeforeAfter.prototype.mouseLeaveOffContainer = function mouseLeaveOffContainer(event) {
        console.log('mouseUpOffLine');
        this.setState({ dragging: false });
        event.preventDefault();
    };

    DiBeforeAfter.prototype.beforeAfterWrapBCR = function beforeAfterWrapBCR() {
        return this.container.getBoundingClientRect();
    };

    DiBeforeAfter.prototype.getPageXY = function getPageXY(event) {
        if (event.touches && event.touches[0]) {
            return event.touches[0];
        } else {
            return event;
        }
    };

    DiBeforeAfter.prototype.mouseDownOnLine = function mouseDownOnLine(event) {
        console.log('mouseDownOnLine');
        var line = event.currentTarget;
        var bcr = this.beforeAfterWrapBCR();
        var minLeftPos = bcr.width * this.state.lineBoundaryPos;
        var maxLeftPos = bcr.width - minLeftPos - this.state.lineWidth;

        var _getPageXY2 = this.getPageXY(event),
            pageX = _getPageXY2.pageX;

        var shiftX = pageX - line.getBoundingClientRect().x + bcr.x;
        console.log(shiftX);
        this.setState({
            dragging: true,
            shiftX: shiftX,
            bcr: bcr,
            minLeftPos: minLeftPos,
            maxLeftPos: maxLeftPos
        });
    };

    DiBeforeAfter.prototype.render = function render() {
        var _this2 = this;

        return React.createElement(
            'div',
            {
                ref: function ref(c) {
                    return _this2.container = c;
                },
                id: 'beforeAfterWrap',
                className: 'beforeAfterWrap abste',
                onTouchMove: this.mouseMoveOnLine.bind(this),
                onTouchEnd: this.mouseUpOffLine.bind(this),
                onMouseMove: this.mouseMoveOnLine.bind(this),
                onMouseUp: this.mouseUpOffLine.bind(this),
                onMouseLeave: this.mouseLeaveOffContainer.bind(this) },
            this.props.selectedCategory !== reStyleCategory && React.createElement(
                'div',
                { id: 'lineWrapper', className: 'lineWrapper abste',
                    style: { left: this.state.linePos + 'px', width: this.state.lineWidth + 'px' },
                    onDragStart: function onDragStart() {
                        return false;
                    },
                    onTouchStart: this.mouseDownOnLine.bind(this),
                    onMouseDown: this.mouseDownOnLine.bind(this) },
                React.createElement('div', { className: 'line' })
            ),
            React.createElement(
                'div',
                { className: 'beforeWrapper abste',
                    style: { width: this.props.selectedCategory !== reStyleCategory ? this.state.linePos + this.state.lineWidth / 2 + 'px' : '100%' } },
                this.props.canvas
            )
        );
    };

    return DiBeforeAfter;
}(Component);

export { DiBeforeAfter as default };